import {afterEveryRender, Component, DOCUMENT, inject, LOCALE_ID} from "@angular/core";
import {RouterLink} from "@angular/router";
import {Header} from "../../layout/header/header";
import {LargeLogoShear} from "../../layout/large-logo-shear/large-logo-shear";

@Component({
  selector: "app-imprint",
  templateUrl: "./imprint.html",
  imports: [
    Header,
    RouterLink,
    LargeLogoShear,
  ],
})
export default class Imprint {
  protected readonly showTelefax = inject(LOCALE_ID) === "de";

  public constructor() {
    const document = inject(DOCUMENT);
    afterEveryRender({
      earlyRead: () => document.getElementById("sg-email-address"),
      write: element => {
        if (!element) return;
        const name = "webmaster";
        const domain = "sersoft.de";
        element.innerText = `${name}@${domain}`;
      },
    });
  }
}
